
import React from 'react';
import { Users, RefreshCcw, UserPlus } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TripMember } from '@/hooks/travel/useTripMembers';
import { TravelerCard } from './TravelerCard';

interface TravelersContentProps {
  members: TripMember[];
  isLoading: boolean;
  error: string | null;
  isAuthorized: boolean;
  currentUserId?: string;
  onRefresh: () => void;
  onInvite: () => void;
}

export const TravelersContent: React.FC<TravelersContentProps> = ({
  members,
  isLoading,
  error,
  isAuthorized,
  currentUserId,
  onRefresh,
  onInvite
}) => {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-glowingTeal" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-center py-6">
        <p className="text-red-500 mb-4">{error}</p>
        <Button 
          variant="outline" 
          onClick={onRefresh}
        >
          <RefreshCcw className="h-4 w-4 mr-2" /> Try Again
        </Button>
      </div>
    );
  }

  if (members.length === 0) {
    return (
      <div className="text-center py-10">
        <Users className="h-12 w-12 mx-auto text-gray-300 mb-3" />
        <p className="text-gray-500 mb-2">No travelers added to this trip yet</p>
        {isAuthorized && (
          <Button 
            variant="outline" 
            onClick={onInvite}
            className="mt-2"
          >
            <UserPlus className="h-4 w-4 mr-2" /> Invite Travelers
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
      {members.map((member) => (
        <TravelerCard 
          key={member.id} 
          member={member}
          currentUserId={currentUserId}
        />
      ))}
    </div>
  );
};
